// Enter all your detials in this file
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import actions from "./assets/techstack/actions.png";
import angular from "./assets/techstack/angular.png";
import argo from "./assets/techstack/argo.png";
import aws from "./assets/techstack/aws.png";
import docker from "./assets/techstack/docker.png";
import dynamodb from "./assets/techstack/dynamodb.png";
import flask from "./assets/techstack/flask.png";
import git from "./assets/techstack/git.png";
import github from "./assets/techstack/github.png";
import gitlab from "./assets/techstack/gitlab.png";
import gitlabci from "./assets/techstack/gitlabci.png";
import java from "./assets/techstack/java.png";
import js from "./assets/techstack/js.png";
import kubernetes from "./assets/techstack/kubernetes.png";
import mongo from "./assets/techstack/mongo.png";
import nodejs from "./assets/techstack/nodejs.png";
import postgres from "./assets/techstack/postgres.png";
import python from "./assets/techstack/python.png";
import react from "./assets/techstack/react.png";
import spring from "./assets/techstack/spring.png";
import terraform from "./assets/techstack/terraform.png";
import typescript from "./assets/techstack/typescript.png";

// Project Images
import binance from "./assets/projects/binance.jpg";
import ghactions from "./assets/projects/actions.jpg";
import fatec from "./assets/projects/fatec.jpg";
import beecrowd from "./assets/projects/beecrowd.png";
import code from "./assets/projects/code.jpg";
import financial from "./assets/projects/financial.jpg";

export const personalDetails = {
  name: "Pedro Henrique",
  img: profile,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkedin: "https://www.linkedin.com/in/pedro-henrique-pereira-almeida",
  github: "https://github.com/PedroHPAlmeida",
};

// Tech Stack and Tools
export const techStackDetails = {
  actions,
  angular,
  argo,
  aws,
  docker,
  dynamodb,
  flask,
  git,
  github,
  gitlab,
  gitlabci,
  java,
  js,
  kubernetes,
  nodejs,
  mongo,
  postgres,
  python,
  react,
  spring,
  terraform,
  typescript,
};

// Enter your Project images here
export const projectImages = {
  "project1": binance,
  "project2": ghactions,
  "project3": fatec,
  "project4": beecrowd,
  "project5": code,
  "project6": financial,
};

// Enter your Contact Details here
export const contactDetails = {
  email: "pedro.6571almeida@gmail.com",
  phone: "+55 11 95094-0828",
};
